import { ClientAdapter } from '@blueshift-ui/fetch/dist/types';

const gql = String.raw;

async function addSubject(
  graphql: ClientAdapter,
  subjectId: number,
  learnerId: string
): Promise<any> {
  if (!subjectId || !learnerId) return;
  try {
    const response = await graphql.makeRequest({
      attempts: 1,
      body: gql`
        mutation ModifyInterestSubject($subjectId: Int!, $userId: String!) {
          addInterestSubject(subjectId: $subjectId, userId: $userId) {
            userId
            interests {
              subjects {
                displayName
                id
              }
            }
            lastModified
          }
        }
      `,
      variables: {
        subjectId,
        userId: learnerId,
      },
    });
    return response;
  } catch (e) {
    console.error(`Error adding subject: ${subjectId}, learner: ${learnerId} - `, e);
    throw e;
  }
}
export default addSubject;
